module.exports = __webpack_public_path__ + "img/banner_beijia.9f39afed.jpg";